/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { querySubwebSidenav, querySidenavPagesByLang } from 'services/requests';

const initialState = {
  sidenav: {},
  tree: {},
  error: null,
  isLoading: true,
  subwebPages: {
    lang: null,
    pages: [],
    isLoading: true,
    error: null,
    currentPage: 1,
    totalRecords: 1,
    search: '',
  }
}

// Slice
// automatically generates action creators
// and action types that correspond to the reducers and state
// https://redux-toolkit.js.org/api/createSlice
const sidenavSlice = createSlice({
  name: 'sidenav',
  initialState,
  reducers: {
    getSidenavStart(state) {
      state.sidenav = {}
      state.error = null
      state.isLoading = true
    },
    getSidenavFailure(state, action) {
      state.sidenav = {}
      state.error = action.payload
      state.isLoading = false
    },
    getSidenavSuccess(state, action) {
      state.sidenav = action.payload
      state.error = null
      state.isLoading = false
    },
    updateTree(state, action) {
      state.tree = action.payload
      state.error = null
    },
    updateSidenavStart(state) {
      state.error = null
      state.isLoading = true
    },
    updateSidenavFailure(state, action) {
      state.error = action.payload
      state.isLoading = false
    },
    updateSidenavSuccess(state, action) {
      state.sidenav = action.payload
      state.error = null
      state.isLoading = false
    },
    getSidenavPagesStart(state, action) {
      state.subwebPages.lang = action.payload.lang
      state.subwebPages.currentPage = action.payload.currentPage
      state.subwebPages.search = action.payload.search
      state.subwebPages.pages = []
      state.subwebPages.isLoading = true
    },
    getSidenavPagesSuccess(state, action) {
      state.subwebPages.pages = action.payload.pages
      state.subwebPages.currentPage = action.payload.currentPage
      state.subwebPages.totalRecords = action.payload.totalRecords
      state.subwebPages.isLoading = false
      state.subwebPages.error = null
    },
    getSidenavPagesFailure(state, action) {
      state.subwebPages.error = action.payload
      state.subwebPages.isLoading = false
      state.subwebPages.pages = []
    },
  }
})

// actions
export const {
  getSidenavStart,
  getSidenavSuccess,
  getSidenavFailure,
  updateTree,
  updateSidenavStart,
  updateSidenavSuccess,
  updateSidenavFailure,
  getSidenavPagesStart,
  getSidenavPagesSuccess,
  getSidenavPagesFailure,
} = sidenavSlice.actions

// thunks
export const fetchSidenav = (
  { subweb, lang }
) => async (dispatch) => {
  if (!subweb) {
    dispatch(getSidenavFailure('Missing subweb parameter'))
    return;
  }
  if (!lang) {
    dispatch(getSidenavFailure('Missing lang parameter'))
    return;
  }
  try {
    dispatch(getSidenavStart())
    const { data } = await querySubwebSidenav(subweb, lang)
    dispatch(getSidenavSuccess(data))
    // request
  } catch (err) {
    // error wasn't due to cancelling
    dispatch(
      getSidenavFailure(
        err && err.response && err.response.status
          ? err.response.status
          : err.message
      ))
  }
}

export const updateSidenav = (
  { subweb, sidenav }
) => async (dispatch) => {
  if (!subweb) {
    dispatch(getSidenavFailure('Missing subweb parameter'))
    return;
  }
  if (!sidenav) {
    dispatch(getSidenavFailure('Missing sidenav parameter'))
    return;
  }
  try {
    dispatch(updateSidenavStart())
    // const { data } = await updateSubwebSidenav(subweb, sidenav)
    dispatch(updateSidenavSuccess(sidenav))
    // request
  } catch (err) {
    // error wasn't due to cancelling
    dispatch(updateSidenavFailure(err.message))
  }
}


// thunks
export const fetchSidenavPages = (
  {
    subweb, lang = 'pt', search = '', page = 1
  }
) => async (dispatch) => {
  if (!subweb) {
    dispatch(getSidenavPagesFailure('Missing subweb parameter'))
    return;
  }
  try {
    dispatch(getSidenavPagesStart({
      lang,
      currentPage: page,
      search,
    }))
    const response = await querySidenavPagesByLang(
      subweb,
      lang,
      {
        params: {
          currentPage: page,
          search,
        }
      },
      true
    )

    const { data: { data: pages, pagination: { currentPage, totalRecords } } } = response
    dispatch(getSidenavPagesSuccess({
      pages, currentPage, totalRecords
    }))
  } catch (err) {
    // error wasn't due to cancelling
    dispatch(getSidenavPagesFailure(err.message.toString()))
  }
}
export default sidenavSlice.reducer
